import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface PhoneFrameProps {
  children?: ReactNode;
  src?: string;
  width?: number | string;
  height?: number | string;
}

const PHONE_WIDTH = 380;
const PHONE_HEIGHT = 760;

export const PhoneFrame = ({ children, src, width, height }: PhoneFrameProps) => {
  console.log(src);
  return (
    <Box
      sx={{
        width: width ?? `min(${PHONE_WIDTH}px, calc((100vh - 200px) / 2))`,
        height: height ?? `min(${PHONE_HEIGHT}px, calc(100vh - 200px))`,
        margin: '0 auto',
        borderRadius: '48px',
        background: '#0b0b0f',
        padding: '3px',
        boxShadow: '0 16px 48px rgba(0, 0, 0, 0.4)',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          borderRadius: '45px',
          background: '#fff',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 96,
            height: 22,
            borderRadius: '12px',
            background: '#0b0b0f',
            zIndex: 2,
          }}
        />

        {src ? (
          <Box
            component="iframe"
            src={src}
            title="Предпросмотр приложения"
            sx={{
              width: '100%',
              height: '100%',
              border: 0,
              display: 'block',
              background: '#fff',
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              overflowY: 'auto',
              boxSizing: 'border-box',
              paddingTop: '42px',
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            {children}
          </Box>
        )}
      </Box>
    </Box>
  );
};
